













import Vue from 'vue'
import ScrollFire from '@/views/mixin/ScrollFire'
import EpisodeTitle from '@/views/templates/kuntama/parts/EpisodeTitle.vue'
import EpisodeBody from '@/views/templates/kuntama/parts/EpisodeBody.vue'

Vue.mixin(ScrollFire)

export default
  components: {
    EpisodeTitle
    EpisodeBody
  }

  data: () ->
    fire_scroll: true
    text: [
      'くんたま王子で取り扱う“燻らのたまご”は、桑野さんのお父さんが製造しています。'
      'お父さんは関西出身でしたが、2013年に仕事の都合で福島県に滞在する機会があり、そこで燻製たまごと出会いました。'
      '福島県では、昔から燻製たまごが地元の人たちに親しまれていましたが、ある日のこと、職人の高齢化に伴い燻製たまごが製造中止になるという噂をお父さんは耳にします。それを聞いたお父さんは、'
      '<span class="red">後継者不足が原因で、長年愛され続けている味が途絶えるのはもったいない</span>'
      'と、一念発起し、事業を引き継ぐことを決意。その後、伝統製法を受け継ぐための修行を経て、福虎を立ち上げました。'
    ]
  created: () ->
    @$options.scroll_target = '.episode1'
